var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container-fluid p-0 bodyArea"},[_c('div',{staticClass:"containerBox"},[_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":_vm.embedUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }